import latexExportsConstants from "./latex-exports-constants.json";
import latexExportsDecorators from "./latex-exports-decorators.json";
import latexExportsFunctions from "./latex-exports-functions.json";
import latexExportsGroups from "./latex-exports-groups.json";
import latexExportsOperatorSymbols from "./latex-exports-operator-symbols.json";
import latexExportsOperators from "./latex-exports-operators.json";
import latexExportsSupplementalOperatorSymbols from "./latex-exports-supplemental-operator-symbols.json";
import latexExportsSymbols from "./latex-exports-symbols.json";

// TODO: rethink this structure
// Latex import uses MathML as intermediate representation, so they're connected
// but MathML can be used as an import source as well, so it shouldn't be tightly coupled with LaTeX configuration
// https://linear.app/corca-research/issue/D-2138/latex-parsing-rethink-importing-data-structure

export type LatexMml =
  | string
  | {
      symbol?: string;
      /**
       * Act as a differential. Basically just d and ∂.
       * It will be a normal variable if it is outside of the integral, and function in the integral.
       * Also, it will be a function in fractions like d/dx.
       */
      isDifferential?: boolean;
      /** Number indicates the level of the integral.
       * For example: ∫ is 1, ∬ is 2
       */
      isIntegral?: number;
      /**
       * Function that closed the integral. Basically just d.
       */
      closesIntegral?: boolean;
      /**
       * Position for decorators that can be over or under.
       * It used for decorators with the same symbol but different positions, like `overline` and `underline`.
       */
      position?: string;

      /**
       * Whether the symbol is stretchy or not.
       * Basically it determines whether we should wrap an expression into group.
       */
      isStretchy?:
        | boolean
        | {
            /**
             * Mininmum number of nodes that should be wrapped into group.
             */
            minChildren: number;
          };

      /**
       * Match identifier node by its content and attributes
       */
      match?: { kind: string; attrs: { mathvariant: string }; value: string }[];
    };

export type LatexJson = Record<
  string,
  {
    mml?: LatexMml;
    imports?: string[];
    exports?: string;
    packages?: string[];
  }
>;

export const latexExportsJson: LatexJson = {
  ...latexExportsConstants,
  ...latexExportsDecorators,
  ...latexExportsFunctions,
  ...latexExportsGroups,
  ...latexExportsOperatorSymbols,
  ...latexExportsSupplementalOperatorSymbols,
  ...latexExportsOperators,
  ...latexExportsSymbols,
};
